export default "__VITE_PUBLIC_ASSET__f4b21c5e__"